/**
 * Returns the current page origin for same-origin checks.
 * Undefined during SSR when window is not available.
 */
export function getCurrentOrigin(): string | undefined {
  return typeof window !== "undefined" ? window.location.origin : undefined;
}
